import { FixaBadge } from "@coworker/apprestructured/src/shared/wrappers/FixaBadge/FixaBadge";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import styles from "./item-badges.module.css";

interface ItemBadgesProps {
  badges: ItemBadge[];
}

export const ItemBadges = ({ badges }: ItemBadgesProps) => {
  return (
    <div className={styles["item-badges-container"]}>
      {badges.map((badge, index) => (
        <FixaBadge
          size="small"
          key={index}
          label={badge.text}
          colour={badge.colour ?? "blue"}
        />
      ))}
    </div>
  );
};
